import instanceQuery from 'graphql/queries/diary/EventGlobalAmendQuery.graphql';
import defaultQuery from 'graphql/queries/diary/EventGlobalAmendDefault.graphql';
import mutationQuery from 'graphql/mutations/diary/EventGlobalAmendMutation.graphql';
import fragment from 'graphql/fragments/diary/EventGlobalAmendFragment.graphql';

const EventGlobalAmend = {
  type: 'EventGlobalAmend',
  title: 'Task Global Amendments',
  formTitle: 'Task Global Amendments',
  formUrl: '/Diary/GlobalAmendments/',
  default: defaultQuery,
  instance: instanceQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'DIARY_GLOBAL_AMENDMENTS',
  resultUrl: '/Diary/DiaryGlobalAmendResultDetails/Workspace/',
};

export default EventGlobalAmend;
